import { Box } from '@mui/material';
import React from 'react';

import { sendUserPortalEvent } from '@/lib/analytics/unified.ts';
import type { CompetitionWithConfig } from '@/lib/api/requests.ts';

import { CTA } from '../_components/CTA.tsx';
import { Section } from '../_components/Section.tsx';
import { StatsCard } from '../_components/StatsCard.tsx';

export const StatsSection = (props: { activeCompetition: CompetitionWithConfig | undefined }) => {
  return (
    <Section
      sx={{
        gap: { xs: '60px', lg: '120px' },
        flexDirection: { md: 'row' },
        alignItems: { md: 'center' },
        maxWidth: '1280px',
        position: 'relative',
        isolation: 'isolate',
      }}
    >
      <Box sx={{ order: { md: 1 }, flex: 5 }}>
        <div className="mb-8 typography-v1-h2">
          Altfor mange har unødvendig høy rente.
          <br />
          Vi vet at mange kan få lavere rente, men de har rett og slett ikke sjekket enda!
        </div>
        <CTA
          activeCompetition={props.activeCompetition}
          onClick={() => {
            sendUserPortalEvent('wake24_competition_cta_stats_clicked');
          }}
        />
      </Box>
      <StatsCard sx={{ flex: 4 }} />
    </Section>
  );
};
